import { historicalImportContracts } from "./historical-import.contract";
import { historicalPaymentImportContracts } from "./historical-payment-import.contract";
import { historicalReportedImportContracts } from "./historical-reported-import.contract";
import { agreementDocumentsContracts } from "./agreement-documents.contract";
import { growthBaselineSuggestionContracts } from "./growth-baseline-suggestion.contract";
import { rebateInvoicesContracts } from "./rebate-invoices.contract";

export const rebatesContracts = {
  historicalImport: historicalImportContracts,
  historicalPaymentImport: historicalPaymentImportContracts,
  historicalReportedImport: historicalReportedImportContracts,
  agreementDocuments: agreementDocumentsContracts,
  growthBaselineSuggestion: growthBaselineSuggestionContracts,
  invoices: rebateInvoicesContracts,
} as const;

// Re-export types and schemas
export * from "./historical-import.contract";
export * from "./historical-payment-import.contract";
export * from "./historical-reported-import.contract";
export * from "./agreement-documents.contract";
export * from "./growth-baseline-suggestion.contract";
export * from "./rebate-invoices.contract";
export * from "./rebate-rule.schema";
